import $ from 'jquery';
import ko from 'knockout';
import moment from 'moment';
import 'moment/locale/da';
import 'moment/locale/de';

moment.locale(document.getElementsByTagName('html')[0].getAttribute('lang'));

export function registerComponent() {
  require('../../modules/bootstrap-datepicker');
  require('../../modules/locales/bootstrap-datepicker.de.min.js');
  require('../../modules/locales/bootstrap-datepicker.da.min.js');
  var datepicker = $.fn.datepicker.noConflict();
  $.fn.bootstrapDP = datepicker;

  ko.components.register('date-picker', {
    template: { element: 'date-picker-template' },
    viewModel: {
      createViewModel: datePickerViewModel
    }
  });
}

function datePickerViewModel(params, componentInfo) {
  var $datepicker = $(componentInfo.element).find('.datepicker-container');

  function DatePickerViewModelConstructor(params) {
    var self = this;

    var enableAllDatesBetweenMinAndMax = true;
    var enableAllWeeks = true;

    if (params.enabledDates) {
      enableAllDatesBetweenMinAndMax = false;
    }

    if (params.enabledWeeks) {
      enableAllWeeks = false;
    }

    // -- Define observables --
    self.selectedStartDate = params.startDate;
    self.selectedDuration = params.duration;

    self.minimumDate = params.minDate;
    self.maximumDate = params.maxDate;

    self.currentMonth = params.currentMonth;

    // -- Prepare the datepicker --
    $datepicker.bootstrapDP({
      language: document.getElementsByTagName('html')[0].getAttribute('lang'),
      calendarWeeks: true,
      weekStart: 1,
      minViewMode: 'days',
      maxViewMode: 'days',
      templates: {
        leftArrow: '<span class="left-arrow"></span>',
        rightArrow: '<span class="right-arrow"></span>'
      },
      beforeShowDay: function datepickerBeforeShowDay(date) {
        // Disable any dates before minDate and after maxDate.
        if (date < self.minimumDate()) {
          return {
            enabled: false,
            classes: 'not-selectable'
          };
        }
        if (date > self.maximumDate()) {
          return {
            enabled: false,
            classes: 'not-selectable'
          };
        }

        var selectedEndDate = self.selectedStartDate() === null ? null : moment(self.selectedStartDate()).add(self.selectedDuration(), 'days').toDate();

        // If enabledDates parameter is used, then only enable those dates.
        if (!enableAllDatesBetweenMinAndMax) {
          if (params.enabledDates.indexOf(moment(date).format('YYYY-MM-DD')) === -1) {
            // Mark the dates between selectedStartDate and selectedEndDate, even if they are disabled.
            if (self.selectedStartDate() !== null && selectedEndDate !== null && selectedEndDate.getTime() === date.getTime()) {
              return {
                enabled: false,
                classes: 'selected'
              };
            }
            else {
              return {
                enabled: false,
                classes: 'not-selectable'
              };
            }
          }
        }

        // Selected start date and selected end date are marked differently.
        if (self.selectedStartDate() !== null && self.selectedStartDate().getTime() === date.getTime()) {
            return 'selected';
        }

        if (selectedEndDate !== null && selectedEndDate.getTime() === date.getTime()) {
          return 'selected';
        }

        // Mark the dates between selectedStartDate and selectedEndDate.
        if (self.selectedStartDate() !== null && selectedEndDate !== null) {
          if (date > self.selectedStartDate() && date < selectedEndDate) {
            return 'in-range';
          }
        }
      }
    })
    .on('changeDate', function datepickerChangeDate(event) {
      self.selectedStartDate(event.date);
    })
    .on('changeMonth', function datepickerChangeMonth(event) {
      self.currentMonth(event.date);
    });

    // Bind some more events
    $datepicker
      .on('mousedown touchstart', 'TD.cw:not(.not-selectable)', function datepickerClickWeek() {
        // Click event isn't working.
        var week = $(this).text();
        var weekNumber = parseInt($(this).text(), 10);

        if (!enableAllWeeks) {
          // Make sure that this week can be booked Saturday-to-Saturday.
          if (params.enabledWeeks.indexOf(weekNumber) === -1) {
            highlightFullWeekNumbers(); // Recalculate the status of each week element.
            return;
          }
        }

        if (week < 10) {
          week = '0' + week;
        }
        var momentEndDate = moment(self.currentMonth().getFullYear() + '-W' + week + '-6');
        var momentStartDate = momentEndDate.clone().subtract(1, 'week');
        self.selectedStartDate(momentStartDate.toDate());
        self.selectedDuration(7);
      })
      .on('mousedown touchstart', 'TH.prev.disabled', function datepickerClickDisabledPrevMonth() {
        if (typeof params.triggeredDisabledPrevMonthChange === 'function') {
          params.triggeredDisabledPrevMonthChange();
        }
      })
      .on('mousedown touchstart', 'TH.next.disabled', function datepickerClickDisabledNextMonth() {
        if (typeof params.triggeredDisabledNextMonthChange === 'function') {
          params.triggeredDisabledNextMonthChange();
        }
      })
      .on('change', function (e) {
        return false;
      });

    self.selectedStartDate.subscribe(function datepickerSelectedStartDateChanged() {
      $datepicker.bootstrapDP('update', self.currentMonth());
      highlightFullWeekNumbers();
    });

    self.selectedDuration.subscribe(function datepickerSelecteDurationChanged() {
      $datepicker.bootstrapDP('update', self.currentMonth());
      highlightFullWeekNumbers();
    });

    self.currentMonth.subscribe(function datepickerMonthChanged() {
      if (typeof params.triggeredMonthChange === 'function') {
        params.triggeredMonthChange();
      }

      $datepicker.bootstrapDP('update', self.currentMonth());
      preventBrowsingOutsideMinMaxDates();
      highlightFullWeekNumbers();
    });

    if (!enableAllDatesBetweenMinAndMax) {
      params.enabledDates.subscribe(function enabledDatesChanged() {
        $datepicker.bootstrapDP('update', self.currentMonth());
      });
    }


    if (!enableAllWeeks) {
      params.enabledWeeks.subscribe(function enabledWeeksChanged() {
        highlightFullWeekNumbers();
        preventBrowsingOutsideMinMaxDates();
      });
    }

    $datepicker.bootstrapDP('update', self.currentMonth());
    highlightFullWeekNumbers();
    preventBrowsingOutsideMinMaxDates();

    // -- Function definitions --
    function highlightFullWeekNumbers() {
      var momentStartDate, momentEndDate, hasSelectedFullWeeks = true;
      var startDateWeek, endDateWeek;
      if (self.selectedStartDate() !== null) {
        momentStartDate = moment(self.selectedStartDate());
        if (momentStartDate.isoWeekday() !== 6) {
          hasSelectedFullWeeks = false;
        }
        else {
          hasSelectedFullWeeks = true;
        }

        if (self.selectedDuration() !== null) {
          momentEndDate = moment(self.selectedStartDate()).add(self.selectedDuration(), 'days');
          if (momentStartDate.isoWeekday() !== 6 || momentEndDate.isoWeekday() !== 6) {
            hasSelectedFullWeeks = false;
          }
          else {
            hasSelectedFullWeeks = true;
          }
        }
      }
      else {
        hasSelectedFullWeeks = true;
      }

      if (hasSelectedFullWeeks && self.selectedStartDate() !== null && self.selectedDuration() !== null) {
        startDateWeek = momentStartDate.isoWeek();
        endDateWeek = momentEndDate.isoWeek();
        $datepicker.find('TD.cw').each(function datepickerEachFullWeekIterator() {
          var $this = $(this);
          var weekNumber = parseInt($this.text(), 10);
          if (weekNumber > startDateWeek && weekNumber <= endDateWeek) {
            $this.addClass('full-week');
          }
          else {
            $this.removeClass('full-week');
          }
        });
      }
      else {
        $datepicker.find('TD.cw').removeClass('full-week');
      }

      // Disable weeks that can't be selected.
      setTimeout(function () {
        // The month isn't rendered when the changeMonth event is triggered. That's why a setTimeout is used, so the datepicker would have the chance to render it before attempting to disable the weeks.
        $datepicker.find('TD.cw').each(function datepickerEachWeekIterator() {
          var $this = $(this);
          var week = $this.text();
          var weekNumber = parseInt(week, 10);
          if (week < 10) {
            week = '0' + week;
          }
          var momentWeekEndDate = moment(self.currentMonth().getFullYear() + '-W' + week + '-6');
          var momentWeekStartDate = momentWeekEndDate.clone().subtract(1, 'week');
          if (momentWeekStartDate.isBefore(moment(), 'day')) {
            $this.addClass('not-selectable');
          }
          else if (momentWeekEndDate.isAfter(self.maximumDate(), 'day')) {
            $this.addClass('not-selectable');
          }
          //else if (self.maximumEndDate() !== null && momentWeekEndDate.isAfter(self.maximumEndDate(), 'day')) {
          //  $this.addClass('not-selectable');
          //}
          else if (!enableAllWeeks && params.enabledWeeks.indexOf(weekNumber) === -1) {
            $this.addClass('not-selectable');
          }
          else {
            $this.removeClass('not-selectable');
          }
        });
      }, 50);
    }

    function preventBrowsingOutsideMinMaxDates() {
      setTimeout(function () {
        // The month isn't rendered when the changeMonth event is triggered. That's why a setTimeout is used, so the datepicker would have the chance to render it before attempting to disable the weeks.
        var momentCurrentMonth = moment(self.currentMonth());
        var momentMinimumDate = moment(self.minimumDate());
        var momentMaximumDate = moment(self.maximumDate());
        if (momentCurrentMonth.isSame(momentMinimumDate, 'month') || momentCurrentMonth.isBefore(momentMinimumDate, 'month')) {
          $datepicker.find('TH.prev').addClass('disabled').on('click.datePickerPreventMonthNavigation', function (event) {
            event.stopImmediatePropagation();
          });
        }
        else {
          $datepicker.find('TH.prev').removeClass('disabled').off('click.datePickerPreventMonthNavigation');
        }

        if (momentCurrentMonth.isSame(momentMaximumDate, 'month') || momentCurrentMonth.isAfter(momentMaximumDate, 'month')) {
          $datepicker.find('TH.next').addClass('disabled').on('click.datePickerPreventMonthNavigation', function (event) {
            event.stopImmediatePropagation();
          });
        }
        else {
          $datepicker.find('TH.next').removeClass('disabled').off('click.datePickerPreventMonthNavigation');
        }
      }, 50);
    }
  }

  return new DatePickerViewModelConstructor(params);
}
